<template>
  <div class="google-map-wrapper">
    <template v-if="google">
      <slot :google-api="google" />
    </template>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps"

export default {
  name: 'GoogleMapWrapper',
  computed: {
    google: gmapApi
  },
  mounted() {
    this.$gmapApiPromiseLazy()
  }
}
</script>
